var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_21_742",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 18C8 17.4477 8.44772 17 9 17C9.55228 17 10 17.4477 10 18V22H22V18C22 17.4477 22.4477 17 23 17C23.5523 17 24 17.4477 24 18V23C24 23.5523 23.5523 24 23 24H9C8.44772 24 8 23.5523 8 23V22V18Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 18C8 17.4477 8.44772 17 9 17C9.55228 17 10 17.4477 10 18V22H22V18C22 17.4477 22.4477 17 23 17C23.5523 17 24 17.4477 24 18V23C24 23.5523 23.5523 24 23 24H9C8.44772 24 8 23.5523 8 23V22V18Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 22H9V23H10V22ZM22 22V23H23V22H22ZM9 16C7.89543 16 7 16.8954 7 18H9V18V16ZM11 18C11 16.8954 10.1046 16 9 16V18H11ZM11 22V18H9V22H11ZM10 23H22V21H10V23ZM21 18V22H23V18H21ZM23 16C21.8954 16 21 16.8954 21 18H23V18V16ZM25 18C25 16.8954 24.1046 16 23 16V18H25ZM25 23V18H23V23H25ZM23 25C24.1046 25 25 24.1046 25 23H23V25ZM23 23H9V25H23V23ZM7 23C7 24.1046 7.89543 25 9 25V23H7ZM9 23V22H7V23H9ZM7 18V22H9V18H7Z",
    fill: "#383838",
    mask: "url(#path-1-inside-1_21_742)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M16 10V18",
    stroke: "#383838",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4",
    d: "M13 12L16 9L19 12",
    stroke: "#383838",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.e7b874c58231df5f8794df46ed8d6f58.svg";
export { ForwardRef as ReactComponent };